import { Reveal } from "./Reveal";

const CHAPTERS = [
  { n: "01", t: "The Sound", d: "Latin heat meets hip-hop grit. Every track is built for the floor — heavy low-end, sharp percussion and melodies that stay with you long after the night ends." },
  { n: "02", t: "The Movement", d: "From TikTok to the club, DJ Código's records travel fast. Reggaetón bounce engineered to move bodies and break languages." },
  { n: "03", t: "The Invitation", d: "Press play, feel the code, and keep listening. New drops land here first — straight from the studio to your speakers." },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto" className="border-y border-white/10 px-6 py-20 sm:px-10 sm:py-28 lg:px-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="mb-12 text-xs font-bold uppercase tracking-[0.3em] text-gold">Manifiesto</p>
        </Reveal>
        <div className="grid gap-10 md:grid-cols-3 md:gap-8">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12}>
              <div className="border-t border-white/15 pt-6">
                <span className="font-display text-5xl font-bold text-gold">{c.n}</span>
                <h3 className="mt-4 font-display text-xl font-semibold uppercase tracking-tight text-white">{c.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-white/60">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
